import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { LinkIcon } from '../../assets/icons'
import { copyToClipboard, getShareURL } from '../../helpers/sharing_helper'

export const linkAction = ({ shareUrl, utmParams }: BaseShareActionArgs) => {
  copyToClipboard(getShareURL(shareUrl, utmParams))
}

export const LinkButton = buildShareButtonComponent({
  action: linkAction,
  ariaLabel: 'ShareLink',
  buttonLabel: 'Link',
  className: 'share-button--share-link',
  icon: LinkIcon,
})

export type LinkButtonProps = Parameters<typeof LinkButton>['0']
